import { lazy, ComponentType } from 'react';

// Import custom icons (static — always needed for desktop icons)
import aboutIcon    from '../assets/icons/about.png';
import projectsIcon from '../assets/icons/projects.png';
import resumeIcon   from '../assets/icons/resume.png';
import contactIcon  from '../assets/icons/contact.png';
import artworksIcon from '../assets/icons/artworks.png';
import figmaIcon    from '../assets/icons/figma.svg';
import guideIcon    from '../assets/icons/guide.svg';
import blogIcon     from '../assets/icons/blogicon.png';
import noteIcon     from '../assets/icons/note.png';

// Lazy-load each window component so it is only fetched when first opened.
// CRA splits each dynamic import into its own JS chunk automatically.
const AboutWindow    = lazy(() => import('../windows/AboutWindow'));
const ProjectsWindow = lazy(() => import('../windows/ProjectsWindow'));
const ResumeWindow   = lazy(() => import('../windows/ResumeWindow'));
const ContactWindow  = lazy(() => import('../windows/ContactWindow'));
const ArtworksWindow = lazy(() => import('../windows/ArtworksWindow'));
const FigmaWindow    = lazy(() => import('../windows/FigmaWindow'));
const BlogWindow     = lazy(() => import('../windows/BlogWindow'));
const NotesWindow    = lazy(() => import('../windows/NotesWindow'));
const WelcomeWindow  = lazy(() => import('../windows/WelcomeWindow'));

interface WindowProps {
  isDarkMode?: boolean;
}

export interface App {
  id: string;
  name: string;
  icon: string;
  component: ComponentType<WindowProps>;
}

export const apps: App[] = [
  {
    id: 'guide',
    name: 'Guide',
    icon: guideIcon,
    component: WelcomeWindow,
  },
  {
    id: 'about',
    name: 'About',
    icon: aboutIcon,
    component: AboutWindow,
  },
  {
    id: 'projects',
    name: 'Projects',
    icon: projectsIcon,
    component: ProjectsWindow,
  },
  {
    id: 'resume',
    name: 'Resume',
    icon: resumeIcon,
    component: ResumeWindow,
  },
  {
    id: 'contact',
    name: 'Contact',
    icon: contactIcon,
    component: ContactWindow,
  },
  {
    id: 'artworks',
    name: 'Artworks',
    icon: artworksIcon,
    component: ArtworksWindow,
  },
  {
    id: 'figma',
    name: 'Figma',
    icon: figmaIcon,
    component: FigmaWindow,
  },
  {
    id: 'blog',
    name: 'Blog',
    icon: blogIcon,
    component: BlogWindow,
  },
  {
    id: 'notes',
    name: 'Notes',
    icon: noteIcon,
    component: NotesWindow,
  },
];
